
export default {
    state: {
        account: null
    },
    
    getters: {
        isLoggedIn(state) {
            return state.account != null;
        },
        
        currentUser(state) {
            return state.account;
        }
    },
    
    actions: {
        login(context, profile) {
            context.commit("login", profile); 
        },
        
        logout(context, item) {
            context.commit("logout");
        }
    },
    
    mutations: {
        login(state, payload) {
            state.account = payload;
        },
        
        logout(state, payload) {
            state.account = null;
        }
    }
}